import axios from "axios";
import { BASE_URL } from "./api";

/**
 * Get all settings with categories
 */
export const getSettings = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/settings/categories`);
    return response.data;
  } catch (error) {
    console.error("[Settings Service] Error fetching settings:", error);
    throw error;
  }
};

/**
 * Update settings
 */
export const updateSettings = async (settings) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/settings`, settings);
    return response.data;
  } catch (error) {
    console.error("[Settings Service] Error updating settings:", error);
    throw error;
  }
};

/**
 * Reset settings to defaults
 */
export const resetSettings = async () => {
  try {
    const response = await axios.delete(`${BASE_URL}/api/settings`);
    return response.data;
  } catch (error) {
    console.error("[Settings Service] Error resetting settings:", error);
    throw error;
  }
};
